import { baseApi } from '@/services/api';
import { Deployment, DeploymentConfig } from './deploymentTypes';

export const deploymentAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeployments: builder.query<Deployment[], { project_id?: string; status?: string }>({
      query: (params) => ({
        url: '/deployment/deployments',
        method: 'GET',
        params,
      }),
      providesTags: ['Deployments'],
    }),
    
    getDeployment: builder.query<Deployment, string>({
      query: (id) => ({
        url: `/deployment/deployments/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Deployments', id }],
    }),
    
    createDeployment: builder.mutation<Deployment, DeploymentConfig>({
      query: (config) => ({
        url: '/deployment/deploy',
        method: 'POST',
        data: config,
      }),
      invalidatesTags: ['Deployments'],
    }),
    
    cancelDeployment: builder.mutation<void, string>({
      query: (id) => ({
        url: `/deployment/deployments/${id}/cancel`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Deployments', id }],
    }),
    
    getDeploymentLogs: builder.query<{ logs: string[] }, string>({
      query: (id) => ({
        url: `/deployment/deployments/${id}/logs`,
        method: 'GET',
      }),
    }),
    
    getPlatforms: builder.query<any[], void>({
      query: () => ({
        url: '/deployment/platforms',
        method: 'GET',
      }),
    }),
    
    getDeploymentStatus: builder.query<any, void>({
      query: () => ({
        url: '/deployment/status',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetDeploymentsQuery,
  useLazyGetDeploymentsQuery,
  useGetDeploymentQuery,
  useCreateDeploymentMutation,
  useCancelDeploymentMutation,
  useGetDeploymentLogsQuery,
  useGetPlatformsQuery,
  useGetDeploymentStatusQuery,
} = deploymentAPI;
